export default (getView) => (nextStepPath) => ({
  ...getView(nextStepPath),

  formValues: {
    firstName: null,
  },

  processFormValues() {
    return {
      firstName: this.formValues.firstName
        ? this.formValues.firstName.trim()
        : this.formValues.firstName,
    }
  },
})
